
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4I77f", function(module, exports) {

$parcel$export(module.exports, "OnboardingCTANudge", () => $a55657b876cff831$export$17d9cbc681ed8f19);

var $gwFzn = parcelRequire("gwFzn");

var $luv00 = parcelRequire("luv00");

var $iFaMg = parcelRequire("iFaMg");

var $3iKAx = parcelRequire("3iKAx");
const $a55657b876cff831$export$17d9cbc681ed8f19 = (props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { hidden: hidden, actionSubjectId: actionSubjectId, children: children, dataVC: dataVC } = props;
    const { isVisible: isVisible, onboardingProps: onboardingProps } = (0, $3iKAx.useOnboardingCTANudge)({
        actionSubjectId: actionSubjectId
    });
    return(// styled elements cannot be the primary component as ssr-placeholder attributes
    // will erroneously be added to the <style> componens during SSR. To fix this,
    // this component is wrapped in a div with an inline style
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": dataVC,
        ...ssrPlaceholderIdProp,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iFaMg.OnboardingNudge), {
        ...onboardingProps,
        ...props,
        hidden: !isVisible && Boolean(hidden ?? true)
    }, children)));
};

});
parcelRegister("3iKAx", function(module, exports) {

$parcel$export(module.exports, "useOnboardingCTANudge", () => $bfe2a85c2a1bbac6$export$5d1fc8cc1f42a85d);

var $gwFzn = parcelRequire("gwFzn");

var $ivb8S = parcelRequire("ivb8S");

var $3hLsK = parcelRequire("3hLsK");

var $9wGTI = parcelRequire("9wGTI");
const $bfe2a85c2a1bbac6$export$5d1fc8cc1f42a85d = ({ actionSubjectId: actionSubjectId })=>{
    const [isVisible, setIsVisible] = (0, $gwFzn.useState)(false);
    const [errors, setErrors] = (0, $gwFzn.useState)([]);
    // ------ Quickstart Nudge Context ------
    const { data: data, loading: quickstartStateLoading, error: quickstartStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $3hLsK.QUICKSTART_STATE_KEYS)));
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const deserializedState = (0, $ivb8S.deserializeState)(data);
    const { openTaskId: openTaskId, openComponentId: openComponentId } = deserializedState;
    const quickstartTask = (0, $3hLsK.TASK_ID_TO_STATE_KEY)[openTaskId];
    // ------ Experiments ----------
    const CTANudgeConditions = openComponentId === actionSubjectId; // QS Button to show nudge is clicked
    const experimentEligible = CTANudgeConditions && (0, $9wGTI.fg)('cc_onboarding_experience');
    const setHidden = ()=>{
        if (!deserializedState[quickstartTask]) setOnboardingState({
            key: quickstartTask,
            value: 'true'
        });
        // Under very rare occasion, onShowProp below run out of order, or not at all.
        // The visibility is controlled by both isVisible and the openComponentId
        // Therefore, ensure that openComponentId is set to none if somehow its still set
        // to the current action
        if (CTANudgeConditions) setOnboardingState({
            key: (0, $3hLsK.QUICKSTART_STATE_KEYS).OPEN_COMPONENT_ID,
            value: 'none'
        });
        setIsVisible(false);
    };
    (0, $gwFzn.useEffect)(()=>{
        if (experimentEligible) setIsVisible(true);
    }, [
        experimentEligible
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!quickstartStateLoading && quickstartStateError) setErrors((prevErrors)=>{
            return [
                ...prevErrors,
                quickstartStateError
            ];
        });
    }, [
        quickstartStateLoading,
        quickstartStateError
    ]);
    const onShow = ()=>{
        if (openComponentId !== 'none') setOnboardingState({
            key: (0, $3hLsK.QUICKSTART_STATE_KEYS).OPEN_COMPONENT_ID,
            value: 'none'
        });
    };
    const onboardingProps = {
        setHidden: setHidden,
        onShow: onShow,
        onboardingErrors: errors
    };
    return {
        isVisible: isVisible,
        onboardingProps: onboardingProps
    };
};

});



//# sourceMappingURL=OnboardingCTANudge.24cad7ed.js.map
